import { Footer, FooterExtraProps, FooterProps } from "@picovico/ui";

import React from "react";
import { useAppSelector } from "store";
import { WebConfig } from "types/index";

export function AppFooter({
  listType,
  logo,
  footerSections,
  footerCopyRightSection,
  ...props
}: Pick<
  FooterProps,
  "listType" | "logo" | "footerSections" | "footerCopyRightSection"
> &
  FooterExtraProps) {
  const config: WebConfig = useAppSelector((state) => state.config);


  return React.createElement(Footer, {
    logo: config.logo || logo,
    description: config.company_info?.description || "",
    footerSections,
    companyName: config.company_info?.name,
    footerCopyRightSection,
    listType,
    ...props,
  });
}
